export { default } from './NotFoundLayout';
